import Helmet from "react-helmet";
import { connect } from "react-redux";
//countUp

//imported
import { DASHBOARD } from "helpers/viewContent";
//services
import DashboardApiIndex from "./DashboardApiComponents";

const Dashboard = () => {
  return (
    <>
      <Helmet title={DASHBOARD.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">Summary</h3>
      </div>

      <DashboardApiIndex />
    </>
  );
};
const mapStateToPros = (state) => {
  return {
    user: state.Auth,
    userProfile: state?.persistStore?.userProfile,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Dashboard);
